// @flow
import React from 'react';
import moment from 'moment';
import { formatCentsToDollars } from 'clark-utils';

import SectionHeader from 'components/shared/section-header';
import InfoCard from 'components/shared/info-card';
import Layout from 'components/shared/layout';
import Receipt from 'assets/icons/receipt.svg';

import { RecieptEmailCopy } from './styles';

const infoCard = charge => {
  const { customNote, receiptId, createdAt, totalAmountInCents } = charge.attributes;
  const date = moment(createdAt).format('MMM Do, YYYY');

  return {
    chargeDetails: {
      amount: formatCentsToDollars(totalAmountInCents),
      description: customNote,
      status: {
        type: 'low',
        text: 'Paid',
      },
    },
    metaDetails: [
      {
        title: 'Bill',
        data: `#${receiptId}`,
      },
      {
        title: 'Date',
        data: date,
      },
    ],
  };
};

const Success = ({ payer, business, charge }: any) => {
  const { chargeDetails, metaDetails } = infoCard(charge);
  return (
    <Layout>
      <SectionHeader
        textAlign="center"
        icon={<Receipt />}
        headline={`Thanks, ${payer.attributes.firstName}!`}
        subHeadline={`You've paid your bill to ${business.attributes.name}`}
      />
      <InfoCard details={metaDetails} charge={chargeDetails} borderColor="tertiary" />
      <RecieptEmailCopy>
        This receipt will be sent to
        {payer.attributes.email}
      </RecieptEmailCopy>
    </Layout>
  );
};

export default Success;



// WEBPACK FOOTER //
// ./src/components/payer/success/index.js